__turbopack_context__.v({
  "clip": "SpotlightPanel-module__vcGALW__clip",
  "clipCompact": "SpotlightPanel-module__vcGALW__clipCompact",
  "clipFixedHeight": "SpotlightPanel-module__vcGALW__clipFixedHeight",
  "clipMatchMedia": "SpotlightPanel-module__vcGALW__clipMatchMedia",
  "divider": "SpotlightPanel-module__vcGALW__divider",
  "featureBody": "SpotlightPanel-module__vcGALW__featureBody",
  "featureCopy": "SpotlightPanel-module__vcGALW__featureCopy",
  "featureIcon": "SpotlightPanel-module__vcGALW__featureIcon",
  "featureItem": "SpotlightPanel-module__vcGALW__featureItem",
  "featureList": "SpotlightPanel-module__vcGALW__featureList",
  "featureTitle": "SpotlightPanel-module__vcGALW__featureTitle",
  "featuresEyebrow": "SpotlightPanel-module__vcGALW__featuresEyebrow",
  "featuresLayout": "SpotlightPanel-module__vcGALW__featuresLayout",
  "introBody": "SpotlightPanel-module__vcGALW__introBody",
  "metricAlignTop": "SpotlightPanel-module__vcGALW__metricAlignTop",
  "metricCaption": "SpotlightPanel-module__vcGALW__metricCaption",
  "metricDecor": "SpotlightPanel-module__vcGALW__metricDecor",
  "metricEyebrow": "SpotlightPanel-module__vcGALW__metricEyebrow",
  "metricLayout": "SpotlightPanel-module__vcGALW__metricLayout",
  "metricValue": "SpotlightPanel-module__vcGALW__metricValue",
  "metricValueCompact": "SpotlightPanel-module__vcGALW__metricValueCompact",
  "metricValueRow": "SpotlightPanel-module__vcGALW__metricValueRow",
  "panel": "SpotlightPanel-module__vcGALW__panel",
  "panelDark": "SpotlightPanel-module__vcGALW__panelDark",
  "panelLight": "SpotlightPanel-module__vcGALW__panelLight",
});
